import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledParentBox } from "../MenuBar/partial/StyledBox.partial";
import {
  PROPERTY_TYPE_VALUES,
  PropertyTypeFilter
} from "../../hooks/Remote/BookingProperty/useRemoteFetchBookingProperty";

type PropertyTypeFilterCardsProps = {
  selectedTypes: string[];
  onToggleType: (type: string) => void;
  onClear: () => void;
  hasFleet?: boolean;
};

const TYPE_TO_LABEL_KEY: Record<PropertyTypeFilter, string> = {
  workplace: "Workplace",
  zone: "Room",
  fleet: "Drawer_Fleet"
};

export function PropertyTypeFilterCards({
  selectedTypes,
  onToggleType,
  onClear,
  hasFleet = true
}: Readonly<PropertyTypeFilterCardsProps>) {
  const { t } = useTranslation();
  const theme = useTheme();
  const typeValues = hasFleet
    ? PROPERTY_TYPE_VALUES
    : (["workplace", "zone"] as const satisfies readonly PropertyTypeFilter[]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
      <StyledParentBox
        picturePath={undefined}
        onClick={onClear}
        data-testid="property-type-filter-card-all"
        sx={{
          minWidth: "140px",
          minHeight: "58px",
          padding: "10px 12px",
          fontSize: 14,
          borderRadius: "8px",
          boxShadow:
            selectedTypes.length === 0
              ? `0 0 0 2px ${theme.palette.primary.main}`
              : `0 0 0 1px ${theme.palette.divider}`
        }}
      >
        <Typography sx={{ fontSize: "inherit", fontWeight: 600 }}>
          {t("_propertyTypeFilter_allTypes")}
        </Typography>
      </StyledParentBox>

      {typeValues.map(type => {
        const isSelected = selectedTypes.includes(type);
        return (
          <StyledParentBox
            key={type}
            data-testid={`property-type-filter-card-${type}`}
            picturePath={undefined}
            onClick={() => onToggleType(type)}
            sx={{
              minWidth: "140px",
              minHeight: "58px",
              padding: "10px 12px",
              fontSize: 14,
              borderRadius: "8px",
              boxShadow: isSelected
                ? `0 0 0 2px ${theme.palette.primary.main}`
                : `0 0 0 1px ${theme.palette.divider}`
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {t(TYPE_TO_LABEL_KEY[type])}
            </Typography>
          </StyledParentBox>
        );
      })}
    </Box>
  );
}
